<template>
  <div class="ask-widget__holder widget-scroll"
       v-show="$settings.use_widget === 1"
       v-bind:style="{ backgroundColor: settings.block_background, color: settings.block_font}">
    <div class="ask-widget__header" id="app_ask-draggable"
         v-bind:style="{ backgroundColor: settings.theme_color, color: settings.button_font }"> {{
        settings.popup_title
      }}
      <span class="ask-widget__header-hide" @click="hideWidget()">_</span>
      <span class="ask-widget__header-close" v-if="answerStatus && settings.feedback_active" @click="openPoll()">&#215;</span>
      <span class="ask-widget__header-close" v-else @click="closeAsk(settings.feedback_active)">&#215;</span>
    </div>
    <div v-if="viewPoll" class="poll-feed">
      <WidgetPoll />
    </div>
    <div v-else>
      <WidgetBody v-if="statusShow || openedUserData == false || settings.statistic_auth == 0" @setAnswerStatus="setBoolAnswer"/>
      <UserDataForm v-else />
    </div>
  </div>
</template>

<script>
import {serverBus} from '../main'
import {dragFunction} from '../services/dragFunction'
import {getUser} from '../services/getUser'
import {closeWidget} from '../services/closeWidget'
import {openReminder} from '../services/openReminder'
// import WidgetBody from './WidgetBodyOld.vue'
import WidgetBody from './WidgetBody'
import UserDataForm from './UserDataForm'
import WidgetPoll from './WidgetPoll'
import Vue from 'vue'

export default {
  name: 'Widget',
  mixins: [dragFunction, getUser, closeWidget, openReminder],
  components: {
    WidgetBody,
    WidgetPoll,
    UserDataForm
  },
  data () {
    return {
      answerStatus: false,
      closeFeedback: false,
      viewPoll: false,
      statusShow: localStorage.getItem('dataHistory') || false,
      openedUserData: true,
      settings: {}
    }
  },
  methods: {
    closeAsk (feedback) {
      let feedbackBool = feedback === 1 ? this.closeFeedback : false
      this.closeWidget(undefined, +localStorage.getItem('openedAnswer'), feedbackBool)
    },
    openPoll () {
      this.viewPoll = true
      this.answerStatus = false
    },
    setBoolAnswer (bool) {
      this.answerStatus = bool
      this.closeFeedback = bool
    },
    showWatchWidget () {
      Vue.prototype.$lastClick = new Date()
      this.ask = this.$ask
      this.openInterval = setInterval(() => {
        let now = new Date()
        let timeDiff = now.getTime() - this.$lastClick.getTime()
        if ((timeDiff / 60000) >= 5) {
          this.openReminder()
        }
      }, 180000)
      this.settings = this.$settings
      this.dragFunction()
      serverBus.$on('openCategories', () => {
        this.openedUserData = false
      })
    }
  },
  mounted () {
    if (this.$settings.use_widget === 1) {
      this.showWatchWidget()
    }
  },
  beforeDestroy () {
    clearInterval(this.openInterval)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Widget.vue